import Layout from '@/layout'

const ToolAssistantRouter = {
  path: '/Performance',
  component: Layout,
  redirect: 'noredirect',
  name: 'Performance',
  meta: {
    title: 'performance',
    icon: 'daohang-ziliaoguanli',
    roles: []
  },
  children: [
    {
      path: 'AIEngine',
      component: () => import('@/views/cargo/v0/Performance/aIEngine'),
      name: 'AIEngine',
      meta: { title: 'aIEngine' },
      roles: ['module_AIEngine']
    },
    {
      path: 'ProvisionReport',
      component: () => import('@/views/cargo/v0/Performance/provisionReport'),
      name: 'ProvisionReport',
      meta: { title: 'provisionReport' },
      roles: ['module_ProvisionReport']
    },
    {
      path: 'ProvisionGenerate',
      component: () => import('@/views/cargo/v0/ProvisionData/ProvisionGenerate'),
      name: 'ProvisionGenerate',
      meta: { title: '计提生成' },
      roles: ['module_provisionGenerate']
    },
    {
      path: 'ProvisionRuleConfig',
      component: () => import('@/views/cargo/v0/ProvisionData/ProvisionRuleConfig'),
      name: 'ProvisionRuleConfig',
      meta: { title: '计提规则配置' },
      roles: ['module_provisionRuleConfig']
    },
    {
      path: 'ProvisionQuery',
      component: () => import('@/views/cargo/v0/ProvisionData/ProvisionQuery'),
      name: 'ProvisionQuery',
      meta: {
        title: '计提查询',
        roles: []
      },
      roles: []
    }
  ]
}

export default ToolAssistantRouter
